import { concat, fn } from '@ember/helper';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed, get, set } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismButton,
  PrismCheckbox,
  PrismIcon,
  PrismTooltip,
} from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import { t } from 'ember-intl';
import { and, lt, not, or } from 'ember-truth-helpers';
import { local } from 'embroider-css-modules';
import { IncrementFor, showDistance } from 'frontend-utils';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';
import { openUrl } from 'frontend-utils/utils/url/open-url';
import getIndexForCompetitorId from 'lumen/utils/competitors/get-index-for-competitor-id';

import styles from './competitor-list-content.module.css';

interface SettingsCompetitorsCompetitorListContentSignature {
  Args: {
    activateSearch: unknown;
    canEditCurrentCompset: unknown;
    competitor: unknown;
    compsets: unknown;
    hotel: unknown;
    isAutocomplete: unknown;
    isLastPrimaryCompetitor: unknown;
    isLastRMSCompetitor: unknown;
    isLoading: unknown;
    isPrimaryCompsetFull: unknown;
    isRMSTabActive: unknown;
    isSecondaryCompsetFull: unknown;
    isSecondaryCompsetVisible: unknown;
    locale: unknown;
    onCompetitorsChange: unknown;
    saveCompset: unknown;
    undoHighlight: unknown;
  };
}

export default class SettingsCompetitorsCompetitorListContent extends Component<SettingsCompetitorsCompetitorListContentSignature> {
  @service declare ajax: Services['ajax'];
  @service declare alerting: Services['alerting'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isPrimaryDisabled() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      this.showLastPrimaryCompetitorMessage ||
      this.showPrimaryCompsetFullMessage
    );
  }

  @computed('args.{competitor.isPrimary,isLastPrimaryCompetitor}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showLastPrimaryCompetitorMessage() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.competitor?.isPrimary && this.args.isLastPrimaryCompetitor;
  }

  @computed('args.{competitor.isRMS,isLastRMSCompetitor}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showLastRMSCompetitorMessage() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.competitor?.isRMS && this.args.isLastRMSCompetitor;
  }

  @computed('args.{competitor.isPrimary,isPrimaryCompsetFull}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showPrimaryCompsetFullMessage() {
    // @ts-expect-error: Incorrect type
    return !this.args.competitor?.isPrimary && this.args.isPrimaryCompsetFull;
  }

  @computed('args.{competitor.isSecondary,isSecondaryCompsetFull}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showSecondaryCompsetFullMessage() {
    return (
      // @ts-expect-error: Incorrect type
      !this.args.competitor?.isSecondary && this.args.isSecondaryCompsetFull
    );
  }

  /**
   * Handles selection of autocomplete option
   * @param  {object} option                 : result from autocomplete, may already be in the compset
   * @param  {string} compsetIdentifier      : either isPrimary or isSecondary, identifies the compset
   * @param  {string} otherCompsetIdentifier : either isPrimary or isSecondary, identifies the other compset
   */
  handleSelectedOption(
    // @ts-expect-error: Incorrect type
    option,
    // @ts-expect-error: Incorrect type
    compsetIdentifier,
    // @ts-expect-error: Incorrect type
    otherCompsetIdentifier,
  ): void {
    if (get(option, compsetIdentifier)) {
      const competitorIndex = getIndexForCompetitorId(
        // @ts-expect-error: Incorrect type
        this.args.compsets?.uniqueCompetitors,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        option.hotelinfo?.id,
      );
      if (
        otherCompsetIdentifier &&
        !get(option, otherCompsetIdentifier) &&
        this.args.compsets
      ) {
        set(
          this.args.compsets,
          'uniqueCompetitors',
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.args.compsets?.uniqueCompetitors.filter(
            // @ts-expect-error: Incorrect type
            (uniqueCompetitor) =>
              uniqueCompetitor ===
              // @ts-expect-error: Incorrect type
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              this.args.compsets?.uniqueCompetitors[competitorIndex],
          ),
        );
      } else {
        set(
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
          this.args.compsets?.uniqueCompetitors[competitorIndex],
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          compsetIdentifier,
          false,
        );
      }
    } else if (otherCompsetIdentifier && get(option, otherCompsetIdentifier)) {
      const competitorIndex = getIndexForCompetitorId(
        // @ts-expect-error: Incorrect type
        this.args.compsets?.uniqueCompetitors,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        option.hotelinfo?.id,
      );
      set(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        this.args.compsets?.uniqueCompetitors[competitorIndex],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        compsetIdentifier,
        !get(option, compsetIdentifier),
      );
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument
      set(option, compsetIdentifier, true);
      // @ts-expect-error: Incorrect type
      set(this.args.compsets, 'uniqueCompetitors', [
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...this.args.compsets.uniqueCompetitors,
        option,
      ]);
    }
    // @ts-expect-error: Incorrect type
    this.args.activateSearch(false);

    // @ts-expect-error: Incorrect type
    this.args.onCompetitorsChange();
  }

  /**
   * Handles selection for actual competitor
   * @param  {object} competitor        : competitor that is already in the compset
   * @param  {string} compsetIdentifier : either isPrimary or isSecondary, identifies the compset
   */
  // @ts-expect-error: Incorrect type
  handleSelection(competitor, compsetIdentifier): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const isSelected = get(competitor, compsetIdentifier);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument
    set(competitor, compsetIdentifier, !isSelected);
    // @ts-expect-error: Incorrect type
    this.args.onCompetitorsChange();
  }

  // @ts-expect-error: Incorrect type
  @action async deleteCompetitor(competitor): Promise<void> {
    const shouldDelete = await this.alerting.showConfirmWarningAlert({
      dangerMode: true,
      title: this.intl.t(
        'settings.competitors.remove_competitor_from_compset',
        {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          competitor: competitor.hotelinfo?.name,
        },
      ),
      buttons: {
        cancel: { text: this.intl.t('general.cancel') },
        confirm: {
          text: this.intl.t('settings.competitors.remove_competitor'),
        },
      },
    });

    if (!shouldDelete) {
      return;
    }

    set(
      // @ts-expect-error: Incorrect type
      this.args.compsets,
      'uniqueCompetitors',
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.args.compsets?.uniqueCompetitors.filter(
        // @ts-expect-error: Incorrect type
        (uniqueCompetitor) => uniqueCompetitor !== competitor,
      ),
    );

    // @ts-expect-error: Incorrect type
    const translationKey = this.args.competitor?.isRMS
      ? 'settings.competitors.competitor_removed_from_rms_compset'
      : 'settings.competitors.competitor_removed_from_compset';

    const toastMessage = this.intl.t(translationKey, {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      competitor: competitor.hotelinfo?.name,
    });

    // @ts-expect-error: Incorrect type
    await this.args.saveCompset(toastMessage);
  }

  @action
  // @ts-expect-error: Incorrect type
  redirectToSource(competitor): void {
    let fromDate = null;

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.args.hotel?.hotelinfo?.timezone) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      fromDate = dayjs.utc().utcOffset(this.args.hotel.hotelinfo.timezone * 60);
    } else {
      fromDate = dayjs.utc();
    }

    const link = generateOtaLink(
      '',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      competitor.hotelinfo?.id,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.args.hotel?.id,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.args.hotel?.isTripadvisorRebranding,
      {
        fromDate,
        los: 1,
      },
      2,
      'competitors',
      false,
    );
    openUrl(`${this.ajax.host}${link}&direct=true`);
  }

  @action
  // @ts-expect-error: Incorrect type
  selectCompset(competitor, compsetIdentifier): void {
    // @ts-expect-error: Incorrect type
    this.args.undoHighlight(competitor, true);

    if (this.args.isAutocomplete) {
      if (compsetIdentifier === 'isPrimary') {
        this.handleSelectedOption(competitor, 'isPrimary', 'isSecondary');
      } else if (compsetIdentifier === 'isSecondary') {
        this.handleSelectedOption(competitor, 'isSecondary', 'isPrimary');
      } else if (compsetIdentifier === 'isRMS') {
        // @ts-expect-error: Incorrect type
        this.handleSelectedOption(competitor, 'isRMS');
      }
    } else {
      this.handleSelection(competitor, compsetIdentifier);
    }
  }

  <template>
    {{! @glint-nocheck }}
    {{! template-lint-disable no-element-event-actions }}
    <div class={{styles.sortable-item-content}}>
      <div class={{local styles "cell" "hotel-name"}}>
        {{#if (and (not @isLoading) (not @isAutocomplete))}}
          {{#if @canEditCurrentCompset}}
            <div
              class={{concat
                styles.drag-handle
                " "
                "drag-handle"
                " "
                "ic-product-tour-competitor-drag-handle"
              }}
            >
              <PrismIcon @name="drag" />
            </div>
          {{/if}}
        {{/if}}
        <div
          class={{concat
            styles.competitor
            " "
            "truncate"
            " "
            (if @competitor.highlighted styles.competitor--is-highlighted)
          }}
          onclick={{fn this.redirectToSource @competitor}}
          role="button"
        >
          <div
            class="truncate"
            data-test-id="hotel-name"
            title={{@competitor.hotelinfo.name}}
          >
            {{@competitor.hotelinfo.name}}
          </div>
        </div>
      </div>
      <div class={{local styles "cell" "hotel-stars"}}>
        <IncrementFor @times={{5}} as |index|>
          <PrismIcon
            @name={{if
              (lt index @competitor.hotelinfo.stars)
              "star-filled"
              "star-outline"
            }}
            @size="extra-small"
          />
        </IncrementFor>
      </div>
      <div class={{local styles "cell" "hotel-distance"}}>
        <p>
          {{showDistance @hotel.hotelinfo @competitor.hotelinfo @locale}}
        </p>
      </div>
      {{#if @canEditCurrentCompset}}
        {{#unless @isRMSTabActive}}
          <div class={{local styles "cell" "hotel-compset"}}>
            <PrismCheckbox
              @checked={{@competitor.isPrimary}}
              @disabled={{this.isPrimaryDisabled}}
              @onChange={{fn this.selectCompset @competitor "isPrimary"}}
              data-test-id="checkbox-primary"
            />
            {{#if this.showLastPrimaryCompetitorMessage}}
              <PrismTooltip
                @text={{t "settings.competitors.delete_disabled.primary"}}
              />
            {{/if}}
            {{#if this.showPrimaryCompsetFullMessage}}
              <PrismTooltip
                @text={{t "settings.competitors.global_limit_reached"}}
              />
            {{/if}}
          </div>

          {{#if @isSecondaryCompsetVisible}}
            <div
              class={{local
                styles
                "cell"
                "hotel-compset"
                "secondary-compset-checkbox"
              }}
            >
              <PrismCheckbox
                @checked={{@competitor.isSecondary}}
                @disabled={{this.showSecondaryCompsetFullMessage}}
                @isSecondary={{true}}
                @onChange={{fn this.selectCompset @competitor "isSecondary"}}
                data-test-id="checkbox-secondary"
              />
              {{#if this.showSecondaryCompsetFullMessage}}
                <PrismTooltip
                  @text={{t "settings.competitors.global_limit_reached"}}
                />
              {{/if}}
            </div>
          {{/if}}
        {{/unless}}

        <div class={{local styles "cell" "hotel-delete"}}>
          <PrismButton
            @buttonType="ghost"
            @icon="bin"
            @isDisabled={{or
              this.showLastPrimaryCompetitorMessage
              this.showLastRMSCompetitorMessage
              @compsets.isModified
            }}
            @onClick={{fn this.deleteCompetitor @competitor}}
            @size="small"
            data-test-id="delete-competitor"
          />

          {{#if this.showLastPrimaryCompetitorMessage}}
            <PrismTooltip
              @text={{t "settings.competitors.delete_disabled.primary"}}
            />
          {{else if this.showLastRMSCompetitorMessage}}
            <PrismTooltip
              @text={{t "settings.competitors.delete_disabled.rms"}}
            />
          {{else if @compsets.isModified}}
            <PrismTooltip
              @text={{t "settings.competitors.save_changes_first"}}
            />
          {{/if}}
        </div>
      {{/if}}
    </div>
  </template>
}
